import {ApiRequest} from '@aofl/api-request';
import {aoflProducts, apiFormatters, environment, libraryApis} from './constants-enumerate';
import MarketingJsonFormatter from './__config/marketing-json-formatter';

const libraryApiRequest = new ApiRequest();
libraryApiRequest.addFormatter(apiFormatters.LIBRARY_JSON, MarketingJsonFormatter);

/**
 *
 * Please keep all api endpoints in alphabetical order, with the exception of request()
 */
class LibraryApiService {
  /**
   *
   * @param {*} apiEndpoint
   * @param {*} payload
   * @param {*} format
   * @param {*} fromCache
   * @param {*} namespace
   */
  static async request(apiEndpoint, payload, format = apiFormatters.LIBRARY_JSON, fromCache = true, namespace = 'default') {
    // const apiHost = environment.DEV ? libraryApis.DEV_HOSTNAME : location.origin;
    const apiHost = environment.DEV ? libraryApis.DEV_HOSTNAME : libraryApis.DEV_HOSTNAME; // Remove. This is for testing on dev only
    const url = `${apiHost}${libraryApis.API_PATH}${apiEndpoint}`;
    const response = await libraryApiRequest.request(url, payload, format, fromCache, namespace);
    return response;
  }

  /**
   *
   * @param {Object} payload
   * @return {Promise}
   */
  static getToken(payload) {
    const request = {
      args: {
        aofl_product_uuid: aoflProducts.ACADEMY_PRODUCT_UUID,
        patron_card_id: payload.patronCardId,
        ip_addr: payload.ipAddress // optional argument
      }
    };
    return this.request('/Library/GetToken/init', request, apiFormatters.LIBRARY_JSON, false);
  }
}

export {
  libraryApiRequest,
  LibraryApiService
};
